






import { defineComponent, SetupContext } from '@vue/composition-api';

export default defineComponent({
  name: 'BottomFixed',
  setup(_props, { emit }: SetupContext) {
    const download = () => {
      emit('download', 'bottom');
    };
    return {
      download
    };
  }
});
